module.exports = __webpack_public_path__ + "static/media/paccf.895f3ee0.jpg";